import { createContext, FC, ReactNode, useCallback, useState } from "react";
import Song from "../models/song";

export type SongPlayerContextType = {
	song: Song | null;
	isPlaying: boolean;
	play: (song: Song) => Promise<any>;
	resume: () => Promise<any>;
	pause: () => Promise<any>;
	stop: () => Promise<any>;
};

type Props = {
	children: ReactNode;
};

export const SongPlayerContext = createContext<SongPlayerContextType | null>(null);

export const SongPlayerProvider: FC<Props> = ({ children }) => {
	const [song, setSong] = useState<Song | null>(null);
	const [isPlaying, setIsPlaying] = useState<boolean>(false);

	const play = useCallback((songToPlay: Song) => {
		return new Promise((resolve: any) => {
			if (songToPlay.id !== song?.id) {
				setIsPlaying(prev => false);
				
				setTimeout(() => {
					setSong(songToPlay);
					setIsPlaying(true);
				}, 0);
			} else {
				setIsPlaying(true);
			}
		});
	}, [song]);

	const resume = useCallback(() => {
		return new Promise((resolve: any) => {
			if (song) {
				setIsPlaying(true);
			}
		});
	}, [song]);

	const pause = useCallback(() => {
		return new Promise((resolve: any) => {
			setIsPlaying(false);
		});
	}, []);

	const stop = useCallback(() => {
		return new Promise((resolve: any) => {
			setSong(null);
			setIsPlaying(false);
		});
	}, []);

	return (
		<SongPlayerContext.Provider value={{ song: song, isPlaying: isPlaying, play: play, resume: resume, pause: pause, stop: stop }}>
			{children}
		</SongPlayerContext.Provider>
	);
};
